// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a56de27","732":"c604da2b","977":"f8aa4dcc"}[chunkId] + ".chunk.js";
};